import { TFunction } from 'i18next';
import { ConversationStatus } from '@/models/conversation.model';

const statusLabels: Record<ConversationStatus, string> = {
  [ConversationStatus.IN_PROGRESS]: 'status_in_progress',
  [ConversationStatus.COMPLETED]: 'status_completed',
};

export const getConversationStatusLabel = (status: ConversationStatus, t: TFunction): string => t(statusLabels[status]);
